import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCircle,
  faCircleCheck,
  faCircleExclamation,
} from '@fortawesome/pro-light-svg-icons';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import {
  QuestionStatus,
  SectionStatus,
} from 'shared/providers/ProgramProvider';

interface Props {
  size?: number;
  className?: string;
  status: SectionStatus | QuestionStatus;
}

const Wrapper = styled.span<{ size: number }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  svg {
    width: ${({ size }) => size}px;
    height: ${({ size }) => size}px;
  }
`;

const StatusIcon: React.FC<Props> = ({ status, size = 18, className }) => {
  const { icon, color } = (() => {
    if (status === 'complete') {
      return { icon: faCircleCheck, color: COLORS.success };
    }
    if (status === 'missing') {
      return { icon: faCircleExclamation, color: COLORS.warningDark };
    }
    return { icon: faCircle, color: COLORS.grayBase };
  })();
  return (
    <Wrapper size={size} className={className} aria-label={status}>
      <FontAwesomeIcon icon={icon} color={color} />
    </Wrapper>
  );
};

export default StatusIcon;
